// 新特徴マスタと旧特徴マスタとして使われているDescriptionのマッピングの集合
// このファイルは新特徴マスタの完全移行後に削除予定です

import type { SearchParamsAttributes } from '@pc/components/Works/Panel/type'

const isKey = <T extends object>(x: T, k: PropertyKey): k is keyof T => {
  return k in x
}
const FEATURE_VALUE_MAPS = {
  touroku: 1,
  haken: 2,
  short_work: 3,
  long: 4,
  choose_shift: 5,
  day_shift: 6,
  'w-work': 7,
  highwage: 8,
  day_saraly: 9,
  week_saraly: 10,
  unexperienced: 11,
  noeducation: 12,
  school: 13,
  students: 14,
  no_age: 15,
  shuhu: 16,
  married: 17,
  free_man: 18,
  foreigner: 19,
  holida: 20,
  parttime: 21,
  free_style: 22,
  traffic: 24,
  meet: 25,
  permanent: 26,
  temporary: 27,
  bike: 28,
  car: 29,
  depachika: 32,
  no_smoking: 33,
  smoking_time: 34,
  uniform: 35,
  active: 37,
  skill: 38,
  use_language: 39,
  short: 41,
  oneoff: 42,
  pierced: 43,
  nail: 44,
  hair_style_color_condition: 45
}

const convertFeatureParams = (
  features: SearchParamsAttributes['features'],
  customCodes: SearchParamsAttributes['custom_codes'],
  welcome: SearchParamsAttributes['welcome'],
  workingTime: SearchParamsAttributes['working_time']
) => {
  const featuresArr = features ?? []
  const customCodesArr = customCodes ?? []
  const workingTimeArr = workingTime ?? []
  const targets = [...featuresArr, ...customCodesArr, welcome ?? '', ...workingTimeArr]
  return targets
    .map((target: string) => {
      if (target !== null && isKey(FEATURE_VALUE_MAPS, target)) {
        return FEATURE_VALUE_MAPS[target]
      }
      return 0
    })
    .filter(Boolean)
}

export default convertFeatureParams
